<template>
  <div class="Visionboard">

    <Visionboard
      v-if="$ready_goals && $ready_commitments"
      :visionboard-id="visionboard_id"></Visionboard>

    <div v-else>
      Loading...
    </div>

    <el-card class="m-4" v-if="SHOW_DEBUG">
      <!--
      <ul>
        <li v-for="goal in goal_list_meta_ready_with_deleted" :key="'goal'+goal.id">
          <a href="#" @click.prevent="onClickGoal(goal.id)">
            {{goal.cachedName}}
            <span v-if="goal.deleted">DELETED</span>
          </a>
        </li>
      </ul>
      -->

      <!-- <el-button @click.prevent="onClickAddGoal">onClickAddGoal</el-button> -->
      <!-- <el-input v-model="new_goal_title" /> -->
      <!-- <pre>Goal List Details: {{goal_list_meta_ready_without_deleted}}</pre> -->

    </el-card>
  </div>
</template>

<script>
import { mapReady } from '@/api/misc'
import Visionboard from "@/components/VisionboardPage/Visionboard"

export default {
  name: "VisionboardPage",
  computed: {
    ...mapReady('goals'),
    ...mapReady('commitments'),

    visionboard_id() {
      return this.$route.params.visionboardId;
    },
  },
  methods: {

    /* DEBUG */
    onClickAddGoal() {
      let new_goal_title = 'New goal title'
      this.$api.goal_create({
        name: new_goal_title,
      });
    },

    // onClickGoal(goalId) {
    //   console.log("onClickGoal", goalId);
    //   alert( JSON.stringify( this.goal_by_id( goalId ), null, 2 ) )
    // }
  },
  components: {
    Visionboard
  }
}
</script>
